import React from "react";
import ImagesGrid from "../components/ImagesGrid";

const ImagesGridPage = () => {
  return <ImagesGrid />;
};

export default ImagesGridPage;
